import { toast } from "react-toastify";
import { call, put, takeLatest } from "redux-saga/effects";
import * as actions from "./Actions";
import * as api from "./Api";
import Types from "./Types";

function* getLastLiveVideo({ payload }) {
  try {
    yield put(actions.studentLiveVideosLoading(true));
    const result = yield call(api.getLastLiveVideo, payload);
    // Handle array response - get the first (most recent) live video
    const liveVideos = result.data.data;
    const lastLiveVideo = liveVideos && liveVideos.length > 0 ? liveVideos[0] : null;
    yield put(actions.getLastLiveVideoSuccess({ data: lastLiveVideo }));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    yield put(actions.getLastLiveVideoFail());
  } finally {
    yield put(actions.studentLiveVideosLoading(false));
  }
}

function* saveLiveVideoSeen({ payload, action }) {
  try {
    yield put(actions.studentLiveVideosLoading(true));
    const result = yield call(api.saveLiveVideoSeen, payload);
    // Handle array response - get the first (most recent) live video
    const liveVideos = result.data.data;
    const lastLiveVideo = liveVideos && liveVideos.length > 0 ? liveVideos[0] : null;
    yield put(actions.saveLiveVideoSeenSuccess({ data: lastLiveVideo }));
    action && action();
    toast.success("Live Video Seen Status Updated Successfully");
  } catch (error) {
    yield put(actions.saveLiveVideoSeenFail());
  } finally {
    yield put(actions.studentLiveVideosLoading(false));
  }
}

export default function* StudentLiveVideosSaga() {
  yield takeLatest(Types.GET_STUDENT_LAST_LIVE_VIDEO_REQUEST, getLastLiveVideo);
  yield takeLatest(Types.SAVE_STUDENT_LIVE_VIDEO_SEEN_REQUEST, saveLiveVideoSeen);
} 